module.exports = __webpack_public_path__ + "img/couples_10_V.c9cf7397.webp";